import dayjs from 'dayjs'

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DATE_FORMAT = 'YYYY-MM-DD'

/**
 * @author：张胜
 * @desc：如 2023-04-12 10:08:55
 * */
export function formatToDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  return dayjs(date).format(format)
}

/**
 * @author：张胜
 * @desc：如 2023-04-12
 * */
export function formatToDate(date?: dayjs.ConfigType, format = DATE_FORMAT): string {
  return dayjs(date).format(format)
}

export const date = dayjs

/**
 * @author：张胜
 * @desc：获取当月包含的天数，若传入date，则指定返回该时间对应月份的天数，否则返回当前时间对应月份的天数
 * */
export function getMonthDayNum(date?: dayjs.ConfigType) {
  return dayjs(date).daysInMonth()
}
/**
 * @author：张胜
 * @desc：如 10:59:59
 * */
export function getTime(date?: dayjs.ConfigType) {
  return dayjs(date).format('HH:mm:ss')
}
/**
 * @author：祁昌玲
 * @desc：判断日期时间组件选择时间区间跨度是否为一年
 * @params: times [2023-04-12, 2023-07-12], times必须是数组且有值
 * */
export function validateTimeDistanceOneYear(times: string[]) {
  if (!times?.length || times?.length < 2) return true
  const firstYear = new Date(times[0]).getFullYear()
  const lastYear = new Date(times[1]).getFullYear()
  const firstMonth = new Date(times[0]).getMonth() + 1
  const lastMonth = new Date(times[1]).getMonth() + 1
  const firstDay = new Date(times[0]).getDate()
  const lastDay = new Date(times[1]).getDate()
  const num = lastYear - firstYear
  if (num === 1) {
    // 判断月
    const num1 = lastMonth - firstMonth
    if (num1 > 0) {
      return false
    } else if (num1 === 0) {
      // 月相同
      // 判断日
      const num2 = lastDay - firstDay
      if (num2 >= 0) {
        return false
      }
    }
  } else if (num > 1) {
    return false
  }
  return true
}
